export const isFeeGamePaymentPlan = (paymentPlan) =>
  paymentPlan === 'non_member_game_fee_no_bet';
